export * from "./form";
export * from "./storage"
export * from './node-tree-helpers'

export function ready(fn: () => void): void {
  if (document.readyState !== "loading") {
    fn();
  } else {
    document.addEventListener("DOMContentLoaded", fn);
  }
}
